(function () {
  "use strict";

  var STORAGE_KEY = "ccm_compare_vehicles_v1";
  var MAX_VEHICLES = 5;
  var memoryState = [];

  function normalizeVehicle(vehicle) {
    if (!vehicle || !vehicle.id) return null;
    return {
      id: String(vehicle.id),
      productId: vehicle.productId ? String(vehicle.productId) : "",
      handle: String(vehicle.handle || ""),
      url: String(vehicle.url || ""),
      source: String(vehicle.source || "ChinaCarMart store"),
      brand: String(vehicle.brand || "ChinaCarMart"),
      model: String(vehicle.model || "Vehicle"),
      year: String(vehicle.year || ""),
      body_style: String(vehicle.body_style || "Vehicle"),
      powertrain: String(vehicle.powertrain || "Vehicle"),
      price_aed: Number.isFinite(Number(vehicle.price_aed)) && Number(vehicle.price_aed) > 0 ? Number(vehicle.price_aed) : null,
      price_display: String(vehicle.price_display || ""),
      power_hp: Number.isFinite(Number(vehicle.power_hp)) && Number(vehicle.power_hp) > 0 ? Number(vehicle.power_hp) : null,
      zero_to_100_sec: Number.isFinite(Number(vehicle.zero_to_100_sec)) && Number(vehicle.zero_to_100_sec) > 0 ? Number(vehicle.zero_to_100_sec) : null,
      range: String(vehicle.range || "Not listed"),
      range_km: Number.isFinite(Number(vehicle.range_km)) && Number(vehicle.range_km) > 0 ? Number(vehicle.range_km) : null,
      engine_battery: String(vehicle.engine_battery || "Not listed"),
      seats: Number.isFinite(Number(vehicle.seats)) && Number(vehicle.seats) > 0 ? Number(vehicle.seats) : null,
      adas: String(vehicle.adas || "Trim dependent"),
      audio: String(vehicle.audio || "Trim dependent"),
      screen: String(vehicle.screen || "Trim dependent"),
      warranty: String(vehicle.warranty || "Market dependent"),
      image: String(vehicle.image || ""),
      availability: String(vehicle.availability || "Store vehicle"),
      source_quality: String(vehicle.source_quality || "Live Shopify product"),
      variant_title: String(vehicle.variant_title || ""),
      color: String(vehicle.color || "")
    };
  }

  function read() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]");
      if (Array.isArray(stored)) memoryState = stored.map(normalizeVehicle).filter(Boolean).slice(0, MAX_VEHICLES);
    } catch (error) {
      console.warn("ChinaCarMart compare selections could not be read.", error);
    }
    return memoryState.slice();
  }

  function write(vehicles) {
    memoryState = (Array.isArray(vehicles) ? vehicles : []).map(normalizeVehicle).filter(Boolean).slice(0, MAX_VEHICLES);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(memoryState));
    } catch (error) {
      console.warn("ChinaCarMart compare selections could not be saved.", error);
    }
    window.selectedVehicles = memoryState.slice();
    document.dispatchEvent(new CustomEvent("ccm:comparechange", { detail: { vehicles: memoryState.slice() } }));
    return memoryState.slice();
  }

  function add(vehicle) {
    var normalized = normalizeVehicle(vehicle);
    if (!normalized) return { added: false, reason: "invalid", vehicles: read() };
    var vehicles = read();
    var existingIndex = vehicles.findIndex(function (item) { return item.id === normalized.id; });
    if (existingIndex >= 0) {
      vehicles[existingIndex] = normalized;
      return { added: false, reason: "updated", vehicles: write(vehicles) };
    }
    if (vehicles.length >= MAX_VEHICLES) return { added: false, reason: "limit", vehicles: vehicles };
    vehicles.push(normalized);
    return { added: true, reason: "added", vehicles: write(vehicles) };
  }

  function remove(id) {
    return write(read().filter(function (vehicle) { return vehicle.id !== String(id); }));
  }

  function has(id) {
    return read().some(function (vehicle) { return vehicle.id === String(id); });
  }

  function navigate(vehicle) {
    var result = vehicle ? add(vehicle) : { vehicles: read() };
    if (vehicle && typeof window.CCMTrackEvent === "function") {
      window.CCMTrackEvent("ccm_compare_vehicle_select", {
        compare_action: "start_compare",
        interaction_context: "vehicle_listing",
        vehicle_id: String(vehicle.id || ""),
        vehicle_name: [vehicle.brand, vehicle.model].filter(Boolean).join(" "),
        vehicle_source: String(vehicle.source || "ChinaCarMart store"),
        compare_count: result.vehicles.length,
        compare_vehicle_set: result.vehicles.map(function (item) { return item.id; }).join("|")
      });
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    window.location.assign(root + "pages/compare");
  }

  memoryState = read();
  window.selectedVehicles = memoryState.slice();
  window.CCMCompareState = {
    storageKey: STORAGE_KEY,
    maxVehicles: MAX_VEHICLES,
    selectedVehicles: memoryState.slice(),
    getAll: read,
    setAll: write,
    add: add,
    remove: remove,
    clear: function () { return write([]); },
    has: has,
    navigate: navigate
  };

  document.addEventListener("ccm:comparechange", function (event) {
    window.CCMCompareState.selectedVehicles = event.detail.vehicles.slice();
  });
}());
